import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import AppMenu from "../../menu";
import TablesData from "../globalTable";
import TableItem from "../globalTable/tableItem";
import { SearchOnly } from "../globalTable/searchandfilter";
import HorizontalTabs from "../../tabs/horizontalTabs";
import { fetchNonEnrollees, getEnrollees, updateActivateNonEnrolle } from "../../../store/enrollee";
import { useDispatch, useSelector } from "react-redux";
import { getFormatedDate } from "../../../utils/constants";
import Loader from "../../common/Loader";
import NonEnrolleesModal from "./NonEnrolleesModal";


const tabLabels = ["Principal Directory", "Dependent Directory"];



const enrolleeData = {
  data: {
    benefits: [
      "Ambulance (Hospital-to-Hospital transfer) (For Immobile Enrollees Only)",
      "Ambulance (Site-to-Hospital) (For RTA only) (For Immobile Enrollees Only)",
      "Emergency Stabilization and Resuscitation Management only",
      "Accommodation (5 days/annum)",
      "Feeding",
      "General Practitioner Consultation/Primary Care Consultation",
      "Subsequent General Reviews",
      "Basic/Primary Laboratory Investigations",
      "Supply of Drugs Prescribed",
      "Tuberculosis (diagnosis and treatment in Govt approved centres)",
      "HIV Diagnosis",
      "HIV Treatment (Govt Approved Centres Only)",
      "Free calls and chats with qualified and certified Doctors for all Primary Care",
      "Free covered drug Pick-up after concluding chats with qualified and certified Doctors at designated Pharmacies",
      "GPS-enabled access to hospital directories when hospital information is needed"
    ],
    basic_plan_demographics: "[\"Ambulance (Hospital-to-Hospital transfer) (For Immobile Enrollees Only)\",\"Ambulance (Site-to-Hospital) (For RTA only) (For Immobile Enrollees Only)\",\"Emergency Stabilization and Resuscitation Management only\",\"Accommodation (5days/annum)\",\"Feeding\",\"General Practitioner Consultation/Primary Care Consultation\",\"Subsequent General Reviews\",\"Basic/Primary Laboratory Investigations\",\"Supply of Drugs Prescribed\",\"Tuberculosis (diagnosis and treatment in Govt approved centres)\",\"HIV Diagnosis\",\"HIV Treatment (Govt Approved Centres Only)\",\"Free calls and chats with qualified and certified Doctors for all Primary Care\",\"Free covered drug Pick-up after concluding chats with qualified and certified Doctors at designated Pharmacies\",\"GPS-enabled access to hospital directories when hospital information is needed\"]",
    status: "pending",
    created_at: "2025-06-03T10:59:30.000000Z"
  }
};


export default function NonEnrolees() {
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch();
  const enrolleesData = useSelector(getEnrollees);
  let [pageNumber, setPageNumber] = useState(1);
  let [pageLists, setPageLists] = useState(10);
  const [selecteId, setSelectId] = useState('');
  const { activetab } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  


  const tabNameToIndex = {
    0: "principal-directory",
    1: "dependent-directory",
  };

  const indexToTabName = {
    "principal-directory": 0,
    "dependent-directory": 1,
  };

  const [tabIndex, setTabIndex] = useState(indexToTabName[activetab]);
  const onChangeTabIndex = (e, newValue) => {
    history.push(`/hmo/dashboard/enrollees/${tabNameToIndex[newValue]}`);
    setTabIndex(newValue);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      dispatch(fetchNonEnrollees(pageLists, pageNumber));
    };
    fetchUsers();
  }, [dispatch, pageNumber, pageLists]);

  const handleChange = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const incrementPageNumber = async () => {
    setPageNumber((pageNumber += 1));
    await dispatch(fetchNonEnrollees(pageLists, pageNumber));
  };

  const decrementPageNumber = async () => {
    setPageNumber((pageNumber -= 1));
    await dispatch(fetchNonEnrollees(pageLists, pageNumber));
  };

  const handleSelectNumber = ({ target }) => {
    if (target.value === "30") {
      setPageLists(30);
    } else if (target.value === "20") {
      setPageLists(20);
    } else {
      setPageLists(10);
    }
  };

  const handleSearchAndFilter = enrolleesData.nonEnroleeList.filter(
    (searched) => {
      if (search === " ") {
        return searched;
      } else if (
        searched.first_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched.last_name
          .toLowerCase()
          .includes(search && search.toLowerCase()) ||
        searched.phone_number.includes(search && search.toLowerCase())
      ) {
        return searched;
      } else {
        return null;
      }
    }
  );

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleSelectAllClick = () => {
    const newSelecteds = enrolleesData.nonEnroleeList.map((n) => n.id);
    setSelected(newSelecteds);
    return;
  };

  const handleOpenModal = (id) => {
    setIsModalOpen(true);
    setSelectId(id)
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitModal = async (formData) => {
    try {
      const res = await dispatch(updateActivateNonEnrolle(formData));
      if(res.status){
        handleCloseModal()
      }
    } catch (error) {
      console.error("Failed to activate enrollee:", error);

    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          marginBottom: "2rem",
          justifyContent: "space-between",
        }}
      >
        <SearchOnly handleSearch={handleChange} searchWord={search} />
        <HorizontalTabs
          tabData={tabLabels}
          tabIndex={tabIndex}
          onTabChange={onChangeTabIndex}
        />
        {/* <FilterOnly /> */}
      </div>
      <Loader visible={enrolleesData.loading} />
      <TableItem
        userType="Enrollee"
        checkBoxes
        tabHeadLabel={[
          "Enrollee",
          "Email Address",
          "Phone Number",
          "Date Created",
        ]}
        action
        tableSize
        tabToolBar
        tabHeadCheck
        numSelectedItem={selected.length}
        rowCount={enrolleesData.nonEnroleeList.length}
        numSelected={selected.length}
        onSelectAllClick={handleSelectAllClick}
        currentPage={enrolleesData.currentPage}
        toPage={enrolleesData.toPage}
        totalPage={enrolleesData.total}
        handleIncrement={() => incrementPageNumber()}
        handleDecrement={() => decrementPageNumber()}
        disabledIncrement={pageNumber >= enrolleesData.lastPage}
        disabledDecrement={pageNumber <= 1}
        handleSelectPageNumber={handleSelectNumber}
        pageSelectValue={pageLists}
        tabBodyData={handleSearchAndFilter.map((item, i) => {
          const isItemSelected = isSelected(item.id);
          const labelId = `enhanced-table-checkbox-${i}`;
          return (
            <TablesData
              labelId={labelId}
              handleItemClick={(event) => handleClick(event, item.id)}
              aria-checked={isItemSelected}
              isItemSelected={isItemSelected}
              key={i}
              checkBoxes
              image
              imageUrl={item.enrolee_photo}
              imgInitials={
                item?.first_name.slice(0, 1) + item?.last_name.slice(0, 1)
              }
              enroleeName={item.first_name + " " + item.last_name}
              enroleeId={item.enrollee_id}
              listItem={[
                item.email,
                item.phone_number,
                getFormatedDate(item.created_at, "YYYY/MMM/DD"),
              ]}
              action={
                <AppMenu
                  menu_name_or_icon={<MoreHorizIcon />}
                  item_names={[
                    {
                      "View More": () =>
                        history.push(`/hmo/dashboard/non-enrollees/${item.id}`),
                    },
                    {
                      "Activate": () => handleOpenModal(item?.id),
                    },
                  ]}
                />
              }
            />
          );
        })}
        tablePagination
      />
      <NonEnrolleesModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitModal}
        enrolleeData={enrolleeData.data}
        selecteId={selecteId}
      />
    </>
  );
}
